module.exports = __webpack_public_path__ + "img/remove-icon.4a7c40ce.png";